import { connect } from 'react-redux';
import FrameworkUtils from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import OrderUtils from 'utils/Order';
import RetailDeliveryFeeItemEN from 'components/SharedComponents/RetailDeliveryFeeItem/locales/RetailDeliveryFeeItem_en_US';
import RetailDeliveryFeeItemFR from 'components/SharedComponents/RetailDeliveryFeeItem/locales/RetailDeliveryFeeItem_fr_CA';

const { getRDF, isZeroPrice, SHIPPING_GROUPS } = OrderUtils;

// A Retail Delivery Fee is never charged on gift-card or electronic (non-physical delivery)
// shipping groups - e.g. MN exempts gift-card orders from the fee (POST-252). Suppress the RDF
// line for those groups so it only shows on physical-delivery shipments. (ECSC-10129)
const RDF_EXEMPT_SHIPPING_GROUP_TYPES = [SHIPPING_GROUPS.GIFT, SHIPPING_GROUPS.ELECTRONIC, SHIPPING_GROUPS.SDU_ELECTRONIC];
const { wrapHOC } = FrameworkUtils;
const { getLocalisedDataFromResource, getTextFromResource } = LanguageLocaleUtils;

const getText = getLocalisedDataFromResource(RetailDeliveryFeeItemEN, RetailDeliveryFeeItemFR);

const mapStateToProps = (state, ownProps) => {
    const defaultText = getTextFromResource(getText, 'defaultText')(state);

    const feesAsArray = state.order?.orderDetails?.priceInfo?.fees;
    const priceInfo = ownProps.priceInfo;
    const isCheckout = ownProps.isCheckout;
    const isOrderConfirmation = ownProps.isOrderConfirmation;
    const orderDetails = state.order?.orderDetails;

    let feeAmount = getRDF({
        feesAsArray,
        priceInfo,
        orderDetails,
        isCheckout,
        isOrderConfirmation
    });

    if (!feeAmount) {
        const orderLevelRDF = orderDetails?.priceInfo?.retailDeliveryFee;

        if (orderLevelRDF && !isZeroPrice(orderLevelRDF)) {
            feeAmount = orderLevelRDF;
        }
    }

    let qty = feeAmount;

    if (isCheckout && !feeAmount) {
        qty = getTextFromResource(getText, 'qtyTbd')(state);
    }

    const hasShippingGroups = state.order?.orderDetails?.shippingGroups?.shippingGroupsEntries?.length;
    const isRdfExemptGroup = RDF_EXEMPT_SHIPPING_GROUP_TYPES.includes(ownProps.shippingGroupType);
    let visible = false;

    if (hasShippingGroups && !isRdfExemptGroup) {
        // Use the address of the shipping group this instance renders for so the check is correct
        // per shipment; fall back to the first group's address for consumers that don't pass a
        // specific group (e.g. checkout / the combined order-level total).
        const shippingGroupAddress =
            ownProps.shippingGroupAddress || state.order?.orderDetails?.shippingGroups?.shippingGroupsEntries[0]?.shippingGroup?.address || {};
        const { postalCode: shippingPostalCode = '', state: shippingState = '' } = shippingGroupAddress;

        visible = Boolean(shippingPostalCode !== '' && shippingState !== '' && feeAmount);
    }

    return {
        defaultText,
        qty,
        visible
    };
};

const withRetailDeliveryFeeItemProps = wrapHOC(connect(mapStateToProps));

export { withRetailDeliveryFeeItemProps };
